/**
 * File extensions accepted by the backend parser/import endpoints. Mirrors
 * `insure.services.file_content_service.SUPPORTED_EXTENSIONS` on the backend. Used as
 * the `accept` prop for import dropzones.
 */
export const PARSER_ACCEPTED_FILE_TYPES =
  '.pdf,.xlsx,.xls,.csv,.tsv,.txt,.docx,.doc,.png,.jpg,.jpeg,.gif,.webp'

/**
 * What an "Other" upload accepts: the parser's formats plus the ones a customer actually
 * has to hand. Nothing reads these files, so the parser's list is no constraint on them.
 * Mirrors `SUPPORTED_EXTENSIONS | AD_HOC_EXTENSIONS` in `insure.views.documents_view`.
 */
export const AD_HOC_ACCEPTED_FILE_TYPES = `${PARSER_ACCEPTED_FILE_TYPES},.heic,.heif,.bmp,.tif,.tiff,.rtf,.odt,.ods,.eml,.msg`
